import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { messengerIntegrationsQuery } from "modules/settings/lib/messenger/messengerIntegrationsQuery"

export function useDeleteMessengerIntegrationMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id }: { id: string }) => {
      await axios.delete(`/integrations/messenger/${id}`)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: messengerIntegrationsQuery().queryKey })
    },
  })
}
